const compose = (...fns: any[]) =>
  fns.reduce((f, g) => (...args: any[]) => f(g(...args)));

export { compose };



// WEBPACK FOOTER //
// ./src/utils.ts